import React, { useState } from "react";
import "./css/Auth.css";

export default function Auth() {
  const [activeTab, setActiveTab] = useState("login"); // default = login

  return (
    <div className="auth-container">
      <h1 className="auth-title">Authentication</h1>

      {/* Toggle Buttons */}
      <div className="tab-buttons">
        <button
          className={activeTab === "login" ? "active" : ""}
          onClick={() => setActiveTab("login")}>
          Login
        </button>
        <button
          className={activeTab === "signup" ? "active" : ""}
          onClick={() => setActiveTab("signup")}>
          Sign Up
        </button>
      </div>

      {/* Forms */}
      <div className="form-area">
        {activeTab === "login" ? (
          <div className="form-box">
            <h2>Login</h2>
            <form>
              <div className="form-group">
                <label>Email</label>
                <input type="email" placeholder="Enter email" required />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" placeholder="Enter password" required />
              </div>
              <button type="submit" className="btn">
                Login
              </button>
            </form>
          </div>
        ) : (
          <div className="form-box">
            <h2>Sign Up</h2>
            <form>
              <div className="form-group">
                <label>Name</label>
                <input type="text" placeholder="Enter name" required />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" placeholder="Enter email" required />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" placeholder="Create password" required />
              </div>
              <button type="submit" className="btn">
                Sign Up
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
